export function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function getStringValue(
    record: Record<string, unknown> | null | undefined,
    key: string,
): string | null {
    const value = record?.[key];
    return typeof value === 'string' && value.trim().length > 0 ? value : null;
}

export function getNumberValue(
    record: Record<string, unknown> | null | undefined,
    key: string,
): number | null {
    const value = record?.[key];
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
